<div id="confirm">
<div mat-dialog-content><h4>{{ mensaje }}</h4></div>
<div mat-dialog-actions>
    <button mat-button class="btnNo" mat-dialog-close>No</button>
    <button mat-button class="btnSi" [mat-dialog-close]="true">Si</button>
</div>
</div>
